import axios from 'axios';
import config from '../config/config'

const apiUrl = config.apiBaseUrl;

export const registrarBitacora = async (valorAnterior, valorNuevo, usuario, accion, tablaModificada) => {
    const registroBitacora = {
      valor_anterior: valorAnterior,
      valor_nuevo: valorNuevo,
      usuario: usuario,
      accion: accion,
      tabla_modificada: tablaModificada, // O ajusta esto según tu tabla
      fecha: new Date(),
    };
  
    try {
      const response = await axios.post(`${apiUrl}/InsertarBitacora`, registroBitacora);
      return response.data;
    } catch (error) {
      console.error('Error al registrar en la bitácora:', error);
      throw new Error('Error al registrar en la bitácora');
    }
  };